<template>
<v-main class="pa-3 pb-4">
  <!-- {{idHelpDeletar}} -->
  <v-dialog v-model="dialogDeletarHelp" max-width="290">
    <v-card>
      <v-card-title class="headline">
        Deseja realmente deletar este item ?
      </v-card-title>

      <v-card-text />

      <v-card-actions>
        <v-spacer />

        <v-btn color="green darken-1" text="text" @click="dialogDeletarHelp = false">
          Voltar
        </v-btn>
        <v-btn color="green darken-1" text="text" @click="deletarHelp()">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-layout justify-center row wrap>
    <v-flex pa-1 hover xs sm1 @click="mudarTabelaPeloTipo(4)">
      <v-card class="rounded-xl" hover dark :color="tipo == 4 ? 'cyan darken-2': 'grey'">
        <v-card-text>
         <div class="text-center font-weight-bold"> Médico </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex pa-1 xs sm1 @click="mudarTabelaPeloTipo(2)">
      <v-card class="rounded-xl" hover dark :color="tipo == 2 ? 'cyan darken-2': 'grey'">
        <v-card-text class="px-0">
         <div class="text-center font-weight-bold"> Recepcionista </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex pa-1 hover xs sm2 @click="mudarTabelaPeloTipo(5)">
      <v-card class="rounded-xl" hover dark :color="tipo == 5 ? 'cyan darken-2': 'grey'">
        <v-card-text class="px-0">
         <div class="text-center font-weight-bold"> Administrador de Unidade </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>

  <br>

  <v-layout justify-center class="mt-2" v-show="clicouEditar">
    <v-card width="1200" class="rounded-xl">
      <v-form ref="form" v-model="valid" class= "mx-4">
        <v-autocomplete v-model="idTituloHelpForm" item-value="idTituloHelp" item-text="titulo" :items="listaTitulos" :readonly="!isEditing" label="Título" :rules="[(v) => !!v || 'Adicione uma Título !!']" persistent-hint required />

        <v-text-field v-model="subtituloForm" :rules="[(v) => !!v || 'Adicione uma Subtítulo !!']" label="Subtítulo" required />
        <br>
        <v-textarea v-model="textoForm" name="input-7-1" box label="Texto" :rules="[(v) => !!v || 'Adicione uma Texto !!']" auto-grow />
        <v-alert :value="alertRetornarHelps" color="warning" icon="check_circle" outlined>
          Salve as alterações ou volte para realizar esta ação !
        </v-alert>

        
      </v-form>
      <v-card-actions>
        <v-spacer />
        <v-btn rounded dark :disabled="desabilitarSalvar" :class="{ red: !valid, green: valid }" @click="submit">
          Salvar
        </v-btn>
        <v-btn text :disabled="desabilitarVoltar" @click="retornarHelp()">
          <v-icon left>
            keyboard_backspace
          </v-icon>voltar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>

  <v-layout v-show="!clicouEditar">
    <v-flex sm12>
      <v-card class="rounded-xl">
        <v-card-title>
          <v-toolbar-title>Dicas de uso do sistema</v-toolbar-title>

          <v-spacer />

          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details />
        </v-card-title>

        <v-data-table  no-data-text="Não há ajuda para esse tipo de funcionário" :headers="headers" :items="listaHelp" :search="search" :loading="carregandoTabela" loading-text="Carregando... Por favor aguarde">
          <template v-slot:items="props">
            <td class="title">
              {{ props.item.titulo }}
            </td>
            <td class="title">
              {{ props.item.subtitulo }}
            </td>
            <td class="title">
              {{ limitarTamanhoString(props.item.texto) }}
            </td>
            <!-- <td class="justify-center layout">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab small v-on="on" @click="editarHelp(props.item)">
                    <v-icon color="success" small>
                      edit
                    </v-icon>
                  </v-btn>
                </template>

              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab small v-on="on" @click="deletarHelpDialog(props.item)">
                    <v-icon color="success">
                      delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Deletar</span>
              </v-tooltip>
            </td> -->
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editarHelp(item)">
              mdi-pencil
            </v-icon>
            <!-- <v-btn fab small v-on="on" @click="deletarHelpDialog(props.item)"> -->
            <v-icon small color="error" @click="deletarHelpDialog(item)">
              delete
            </v-icon>
            <!-- </v-btn> -->
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Sua busca por "{{ search }}" não encontrou resultados.
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout style="height: 90px; position: relative" right bottom>
    <v-btn v-show="!clicouEditar" id="mybutton" top-of="footer" right fab dark color="teal darken-4" @click="cadastrarHelp(tipo)">
      <v-icon dark>
        add
      </v-icon>
    </v-btn>
  </v-layout>
  <v-layout style="height: 90px; position: relative">
    <v-btn v-show="!clicouEditar" id="mybuttonTitulo" large rounded to="listaTituloHelp" depressed color="primary">
      Títulos
    </v-btn>
  </v-layout>
</v-main>
</template>

<script>
import administradorDesenvolvimentoService from "../../services/administradorDesenvolvimento.service";

export default {
  name: "FuncionariosOnline",
  props: {
    msg: String
  },
  data() {
    return {
      idHelpDeletar: "",
      dialogDeletarHelp: false,
      alertRetornarHelps: false,
      alertEditarHelp: true,
      page: 1,
      desabilitarSalvar: false,
      desabilitarVoltar: false,
      clicouEditar: false,
      valid: false,
      carregandoTabela: false,
      tituloEscolhido: "",
      listaTitulos: [],
      subtituloForm: "",
      idTituloHelpForm: "",
      textoForm: "",
      search: "",
      intFuncionarioOnline: 1,
      qtdVagasVazio: false,
      listaServicos: [],
      tipo: "",
      diaSemanaLista: "",
      dialogErroQuantidade: false,
      listaFuncionariosTabela: [],
      listaFuncionarios: [],
      listaHelp: [],
      respostaServidor: false,
      isEditing: true,
      dialog2: false,
      headers: [{
          text: "Título",
          align: "center",
          value: "titulo"
        },
        {
          text: "Subtitulo",
          value: "subtitulo",
          align: "center"
        },
        {
          text: "Texto",
          value: "texto",
          align: "center"
        },
        {
          text: '--Ações--',
          value: "actions",
          align: "center",
          sortable: false
        }
        // { text: 'Função', value: 'quantVagas', align: 'center', sortable: true },
      ],
      listaAdministradores: [],
      user: null
    };
  },

  computed: {
    limitarTamanhoTexto() {}
  },
  mounted() {
    console.log("em servicos unidade...");
    this.user = this.$store.getters.usuario;
    if (this.user.tipo != 10) {
      this.$router.push("/login");
      return;
    }
    this.tipo = 4;
    this.retornarHelp();
    //this.retornarFuncionariosOnline();
    //this.retornarTituloHelp()
  },

  created() {
    console.log("created...");
  },

  methods: {
    limitarTamanhoString(text) {
      if (text.length > 80) {
        return text.substr(0, 80) + "...";
      } else {
        return text;
      }
    },

    editarHelp(item) {
      console.log("editar help", item);
      this.retornarTituloHelp();
      this.idTituloHelpForm = item.idTituloHelp; // 1,2 ou 3 n muda
      this.tituloEscolhido = item.idHelp;

      this.subtituloForm = item.subtitulo;
      this.textoForm = item.texto;
      this.clicouEditar = true;
    },

    deletarHelpDialog(item) {
      this.idHelpDeletar = item.idHelp;
      this.dialogDeletarHelp = true;
      console.log("editar deletarHelp", item);
    },

    deletarHelp() {
      console.log("em deletar help");
      administradorDesenvolvimentoService.administradorDesenvolvimento
        .deletarHelp(this.idHelpDeletar)
        .then(rsp => {
          console.log("rsp deletarHelp:", rsp.data);
          this.dialogDeletarHelp = false;
          this.retornarHelp();
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    retornarTituloHelp() {
      administradorDesenvolvimentoService.administradorDesenvolvimento
        .retornarTituloHelp()
        .then(rsp => {
          console.log("rsp retornarTituloHelp:", rsp.data);
          this.listaTitulos = rsp.data;
          //this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    retornarHelp() {
      this.carregandoTabela = true;
      //this.desabilitarVoltar = true
      //this.desabilitarSalvar = true
      administradorDesenvolvimentoService.administradorDesenvolvimento
        .retornarHelp(this.tipo)
        .then(rsp => {
          console.log("rsp retornarHelp:", rsp);
          if (rsp.status == 200) {
            this.listaHelp = rsp.data;
            this.carregandoTabela = false;
            this.desabilitarVoltar = false;
            this.desabilitarSalvar = false;
            this.clicouEditar = false;
          }
        })
        .catch(err => {
          //handle your error here
          this.carregandoTabela = false;
          this.blockMethod = false;
          console.log(err);
        });
    },

    mudarTabelaPeloTipo(tipo) {
      if (this.clicouEditar) {
        this.alertRetornarHelps = true;
        setTimeout(() => {
          this.alertRetornarHelps = false;
        }, 4000);
        return;
      }
      this.intFuncionarioOnline = tipo;
      this.tipo = tipo;
      this.retornarHelp();
    },

    submit() {
      if (this.$refs.form.validate()) {
        //this.desabilitarSalvar = true
        //this.desabilitarVoltar = true

        administradorDesenvolvimentoService.administradorDesenvolvimento
          .alterarHelp(
            this.idTituloHelpForm,
            this.subtituloForm,
            this.textoForm,
            this.tituloEscolhido
          )
          .then(rsp => {
            console.log("rsp alterarHelp:", rsp.data);
            if (rsp.data == true) {
              this.desabilitarVoltar = false;
              this.desabilitarSalvar = false;
              this.sucessoLogin = true;
              this.retornarHelp();
            }
            if (rsp.data == false) {}
          })
          .catch(err => {
            // handle your error here
            console.log(err);
          });
      }
    },

    cadastrarHelp(tipo) {
      this.$router.push({
        name: "cadastrarHelp",
        params: {
          tipo: tipo
        }
      });
    }
  }
};
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}

#mybuttonTitulo {
  position: fixed;
  bottom: 30px;
  right: 85px;
}

.input-qty {
  width: 60px;
  height: 25px;
  border: 2px solid #80cbc4;
  border-radius: 5px;
}

.rounded-card {
  border-radius: 35px;
}
</style>
